<template>
  <div>
    <loading :active.sync="isLoading" loader="dots"></loading>
    <div class="validate-wrap" v-if="feedbackForm === null">
      <div
        style="
          text-align: center;
          background-color: #cbdafc;
          border-radius: 25px;
          padding: 5px;
          width: 125px;
          margin: 0 auto;
          margin-bottom: 30px;
        "
      >
        滿意度問卷
      </div>
      <img src="@/assets/img/工作區域 7.png" alt="" />
      <el-select
        v-model="currentPerson.Guid"
        placeholder="請選擇人員"
        style="width: 100%"
      >
        <el-option
          v-for="person in personList"
          :key="person.Value"
          :label="person.Text"
          :value="person.Value"
        >
        </el-option>
      </el-select>

      <el-input
        v-model="currentPerson.IdNo"
        placeholder="請輸入身分證字號"
        style="width: 100%"
      ></el-input>
      <el-button type="primary" @click="validatePerson">確認</el-button>
    </div>

    <el-form
      v-if="feedbackForm !== null && completed === false"
      :model="feedbackForm"
      ref="feedbackForm"
      class="feedback-form"
    >
      <div class="form-title">面試意見回饋表</div>

      <div class="text-center">
        <el-button
          class="mb-2"
          type="primary"
          :disabled="writing"
          v-if="!writing"
          @click="writing = true"
          >開始填寫</el-button
        >
      </div>
      <table class="feedback-table">
        <tr>
          <th scope="row" rowspan="3" class="text-center">基本資料</th>
          <th scope="row">姓名</th>
          <td>
            <el-form-item>
              <el-input
                v-model="feedbackForm.Arrange.Name"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <th scope="row">Email</th>
          <td>
            <el-form-item>
              <el-input
                v-model="feedbackForm.Arrange.Email"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </td>
        </tr>

        <tr>
          <th scope="row">手機號碼</th>
          <td>
            <el-form-item>
              <el-input
                v-model="feedbackForm.Arrange.Phone"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </td>
        </tr>
        <template v-for="(Categories, cIndex) in feedbackForm.Categories">
          <tr :key="Categories.Guid" v-if="Categories.Name">
            <th scope="row" :rowspan="Categories.Questions.length + 1">
              {{ Categories.Name }}
            </th>
          </tr>
          <template v-if="Categories.Name">
            <tr
              v-for="(Questions, qIndex) in Categories.Questions"
              :key="Questions.Guid"
            >
              <th scope="row">{{ Questions.Title }}</th>
              <td>
                <el-form-item
                  :prop="
                    'Categories.' + cIndex + '.Questions.' + qIndex + '.Value'
                  "
                  :rules="[
                    {
                      required:
                        feedbackForm.Categories[0].Questions[0].Value ===
                          'false' &&
                        cIndex === 0 &&
                        (qIndex === 1 ||
                          qIndex === 2 ||
                          qIndex === 3 ||
                          qIndex === 4)
                          ? false
                          : true,
                      message: '必填',
                    },
                  ]"
                >
                  <el-radio-group
                    v-model="Questions.Value"
                    :disabled="
                      !writing ||
                      (feedbackForm.Categories[0].Questions[0].Value ===
                        'false' &&
                        cIndex === 0 &&
                        (qIndex === 1 ||
                          qIndex === 2 ||
                          qIndex === 3 ||
                          qIndex === 4))
                    "
                    @change="questionOneChange($event, cIndex, qIndex)"
                  >
                    <el-radio-button label="true">是</el-radio-button>
                    <el-radio-button label="false">否</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </td>
            </tr>
          </template>
          <template v-else>
            <template v-for="Questions in Categories.Questions">
              <tr :key="`${Questions.Guid}+q`">
                <th scope="col" colspan="3">{{ Questions.Title }}</th>
              </tr>
              <tr :key="`${Questions.Guid}+a`">
                <td colspan="3">
                  <el-form-item>
                    <el-input
                      :disabled="!writing"
                      style="width: 100%"
                      type="textarea"
                      :rows="2"
                      placeholder="請輸入內容"
                      v-model="Questions.Value"
                    >
                    </el-input>
                  </el-form-item>
                </td>
              </tr>
            </template>
          </template>
        </template>
      </table>

      <div class="text-center">
        <el-button
          type="primary"
          round
          style="margin-top: 10px"
          v-if="writing"
          @click="submitForm('feedbackForm')"
        >
          送出
        </el-button>
      </div>
    </el-form>

    <div class="complete-wrap" v-if="completed">
      <img src="@/assets/img/complete_02.png" alt="" />
      <div class="text">問卷已送出</div>

      <el-button type="primary" @click="goLogin">離 開</el-button>
    </div>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>確實填寫完成?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendFeedback">確 認</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* global $ */
import { mapGetters } from "vuex";

export default {
  name: "RoomScheduleSetting",

  data() {
    return {
      currentPerson: {
        Guid: null,
        IdNo: null,
      },
      personList: [],
      dialogVisible: false,
      writing: false,
      feedbackForm: null,
      form: {
        radio1: null,
        radio2: null,
        radio3: null,
        radio4: null,
        radio5: null,
      },
      completed: false,
    };
  },

  methods: {
    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    getTodayCheckIn() {
      const vm = this;

      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.getTodayCheckIn()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.personList = response.data.Data;
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    validatePerson() {
      const vm = this;

      localStorage.clear();
      localStorage.setItem("i18n-lang", "zh-TW");
      this.$cookies.keys().forEach((cookie) => this.$cookies.remove(cookie));

      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.validatePerson(vm.currentPerson)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.feedbackForm = response.data.Data;
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogVisible = true;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    sendFeedback() {
      const vm = this;

      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.sendFeedback(vm.feedbackForm)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.dialogVisible = false;
            vm.completed = true;
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    questionOneChange(val, cIndex, qIndex) {
      if (cIndex === 0 && qIndex === 0 && val === "false") {
        this.feedbackForm.Categories[0].Questions[1].Value = null;
        this.feedbackForm.Categories[0].Questions[2].Value = null;
        this.feedbackForm.Categories[0].Questions[3].Value = null;
        this.feedbackForm.Categories[0].Questions[4].Value = null;

        this.$refs["feedbackForm"].clearValidate([
          "Categories.0.Questions.1.Value",
          "Categories.0.Questions.2.Value",
          "Categories.0.Questions.3.Value",
          "Categories.0.Questions.4.Value",
        ]);
      }
    },
    goLogin() {
      localStorage.clear();
      localStorage.setItem("i18n-lang", "zh-TW");
      this.$cookies.keys().forEach((cookie) => this.$cookies.remove(cookie));
      this.$router.push({ path: "/login" });
    },
  },

  computed: {
    ...mapGetters(["lang"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getTodayCheckIn();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.validate-wrap {
  max-width: 600px;
  margin: 0 auto;
  padding: 60px;
  text-align: center;
  img {
    width: 300px;
    margin-bottom: 40px;
  }
  .el-select,
  .el-input {
    margin-bottom: 20px;
  }
}
.feedback-form {
  max-width: 960px;
  margin: 20px auto;
  border-radius: 10px;
  background-color: #fff;
  padding: 10px;
  table {
    width: 100%;
  }
  .form-title {
    text-align: center;
    font-weight: bold;
    margin: 10px 0;
  }
  th {
    background-color: #f5f5f5;
    font-weight: normal;
    white-space: nowrap;
  }
  td,
  th {
    border: 1px solid #ccc;
    padding: 5px;
    font-size: 0.9em;
  }
  .el-select {
    width: 100%;
  }
  .el-checkbox {
    transform: scale(1.5);
    margin-left: 10px;
    margin-right: 10px;
  }
  /deep/ .el-form-item__error {
    background-color: #f56c6c;
    color: #fff;
    padding: 3px 10px;
    border-radius: 25px;
    float: right;
  }
}

.complete-wrap {
  max-width: 600px;
  margin: 0 auto;
  padding: 60px;
  text-align: center;
  img {
    width: 300px;
    margin-bottom: 40px;
  }
  .text {
    margin-bottom: 40px;
  }
}
</style>
